module.exports = "img/icon-context-mute.c8f99f3.svg";